import React from 'react';
import { Button, FormGroup, Alert } from 'react-bootstrap';
import QRCode from 'qrcode.react';
import { IQRCodeScennerProps } from '../../types/propTypes';
import { IQRCodeScennerState } from '../../types/stateTypes';
import LoginService from '../../services/login/login-service';
import { IAuthResponse, IQRCodeFormField } from '../../models/login';
import { Common } from '../../utils/constants';
import { Formik, Field } from 'formik';
import { ReactstrapInput } from '../reactstrap-formik';
import { QRCodeValidationSchema } from '../../validation/login/login-validation';
class QRCodeScanner extends React.Component<IQRCodeScennerProps, IQRCodeScennerState> {
    state: IQRCodeScennerState;
    loginService: LoginService;
    private initialState: IQRCodeFormField = {
        securityCode: '',
    };
    constructor(props: IQRCodeScennerProps) {
        super(props);
        this.state = {
            apiError: '',
        };
        this.loginService = new LoginService();
    }

    handleSecurityCode = (value: IQRCodeFormField) => {
        if (this.props.stage === Common.AuthStage.QR_SCAN) {
            this.loginService
                .authVerifyCodeTotp(this.props.user, value.securityCode)
                .then(async (res: IAuthResponse) => {
                    this.setState({ apiError: '' });
                    this.props.onAuthUser(res);
                })
                .catch((error) => {
                    let errMsg = '';
                    if (
                        error.code === Common.Auth.CODE_MISS_MATCH_EXCEPTION ||
                        error.code === Common.Auth.ENABLE_MFA_TOKEN_EXCEPTION
                    ) {
                        errMsg = this.props.t('login.errors.securityCodeInvalid');
                    } else {
                        errMsg = this.props.t('login.errors.generalError');
                    }
                    this.setState({ apiError: errMsg });
                });
        } else {
            this.loginService
                .verifyCodeOTP(this.props.user, value.securityCode)
                .then(async (res: IAuthResponse) => {
                    this.setState({ apiError: '' });
                    this.props.onAuthUser(res);
                })
                .catch((error) => {
                    let errMsg = '';
                    if (
                        error.code === Common.Auth.CODE_MISS_MATCH_EXCEPTION ||
                        error.code === Common.Auth.ENABLE_MFA_TOKEN_EXCEPTION
                    ) {
                        errMsg = this.props.t('login.errors.securityCodeInvalid');
                    } else {
                        errMsg = this.props.t('login.errors.generalError');
                    }
                    this.setState({ apiError: errMsg });
                });
        }
    };

    render() {
        const { t, children } = this.props;
        return (
            <>
                {this.state.apiError.length > 0 && (
                    <Alert key="errorAlert" variant="danger">
                        {this.state.apiError}
                    </Alert>
                )}
                {this.props.stage === Common.AuthStage.QR_SCAN && (
                    <>
                        <div className="qr-code">
                            <QRCode value={this.props.qrString} size={100} />
                        </div>
                        <br />
                    </>
                )}
                <Formik
                    initialValues={this.initialState}
                    onSubmit={this.handleSecurityCode}
                    validationSchema={QRCodeValidationSchema(t)}
                >
                    {(props) => {
                        const { handleSubmit } = props;
                        return (
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <Field
                                    type="text"
                                    name="securityCode"
                                    id="securityCode"
                                    placeholder={t('login.qrCode.placeholderSecurityCode')}
                                    component={ReactstrapInput}
                                />
                                <FormGroup>
                                    <Button
                                        type="submit"
                                        color="primary"
                                        className="btn mt-2 w-100"
                                        title={t('login.button.login')}
                                    >
                                        <span>{t('login.button.login')}</span>
                                    </Button>
                                </FormGroup>
                            </form>
                        );
                    }}
                </Formik>
                {children}
            </>
        );
    }
}
export default QRCodeScanner;
